import { ChartCalculationResult } from '../claim-details/chart-calculation';

export interface ClaimFinancialSummaryData {
    charge: number;
    contractValue: number;
    allowed: number;
    payerPaid: number;
    patientResponsibility: number;
    patientPaid: number;
    outstanding: number;
}

const round2 = (value: number): number => Math.round(value * 100) / 100;

export const toClaimFinancialSummary = (calculated: ChartCalculationResult): ClaimFinancialSummaryData => {
    const charge = round2(calculated.charge || 0);
    const contractValue = round2(calculated.contracted || 0);
    const allowed = round2(calculated.payerAllowed || 0);
    const payerPaid = round2(calculated.payerPaid);
    const patientPaid = round2(calculated.patientPaid);
    const patientResponsibility = round2(calculated.patientPending + calculated.patientPaid);
    const outstanding = round2(Math.max(0, contractValue - payerPaid - patientPaid));

    return {
        charge,
        contractValue,
        allowed,
        payerPaid,
        patientResponsibility,
        patientPaid,
        outstanding,
    };
};
